export enum CalculationNotificationType {
    NONE,
    INFO,
    WARNING,
    ERROR
}

export function getPrettyNotificationType(notificationType: number): string {
    return ['', 'Information', 'Warning', 'Error'][notificationType];
}
